//@ts-nocheck
import { Table, Text } from '@wework/dieter-ui'
import React from 'react'
import pluralize from 'pluralize'
import _ from 'lodash'
import InteractableList from '../Content/InteractableList'
import { CompareArrows } from '../Icons'

export default function SearchResultDrawer({
  spaces,
  onClick,
  currentFloorUUID,
  onMouseOut,
  onMouseOver,
}) {
  const sortedSpaces = [...spaces]
  sortedSpaces.sort((spaceA, spaceB) => {
    const floorA = _.get(spaceA, 'index.floorUUID')
    const floorB = _.get(spaceB, 'index.floorUUID')
    if (floorA !== floorB) {
      if (floorA === currentFloorUUID) {
        return -1
      }

      if (floorB === currentFloorUUID) {
        return 1
      }
    }

    const numberA = spaceA.number
    const numberB = spaceB.number

    if (numberA < numberB) {
      return -1
    }
    if (numberA > numberB) {
      return 1
    }
    return 0
  })

  const uniqueSpaces = _.uniqBy(sortedSpaces, space => {
    if (_.get(space, 'reservable.officeNumber') && space.number) {
      return `${space.reservable.officeNumber}-${space.number}`
    }
    return _.get(space, 'reservable.officeNumber') || space.number
  })

  const renderItem = data => {
    const number = _.get(data, 'index.number') || data.number
    const officeNumber = _.get(data, 'reservable.officeNumber', '')
    const reservations = _.get(data, 'reservable.reservations', [])

    const sortedReservations = _.orderBy(reservations, ['startedOn'], ['asc'])

    return (
      <>
        <Table.Cell>
          <Text>{number}</Text>
        </Table.Cell>
        <Table.Cell>
          <Text>{officeNumber}</Text>
        </Table.Cell>
        <Table.Cell>
          <Text>
            {_.size(sortedReservations) > 0 ? (
              <div
                style={{
                  flexBasis: '40%',
                  textAlign: 'left',
                  lineHeight: '1.5em',
                  flexGrow: 1,
                  paddingLeft: '1em',
                }}
              >
                {sortedReservations.length
                  ? sortedReservations[0].account.name
                  : '-'}
                {sortedReservations.length > 1 && (
                  <em
                    style={{
                      display: 'block',
                      color: '#666666',
                    }}
                  >
                    <CompareArrows /> {sortedReservations[1].account.name}
                  </em>
                )}
              </div>
            ) : (
              <div
                style={{
                  flexBasis: '40%',
                  textAlign: 'left',
                  lineHeight: '1.5em',
                  flexGrow: 1,
                  paddingLeft: '1em',
                }}
              />
            )}
          </Text>
        </Table.Cell>
      </>
    )
  }

  let resultText = `Found ${uniqueSpaces.length} results`
  const foundInFloors = new Set([])
  uniqueSpaces.forEach(item => {
    const floor = _.get(item, 'reservable.floor')
    if (floor) {
      foundInFloors.add(floor)
    }
  })

  const floors = Array.from(foundInFloors)
  if (floors.length > 0) {
    floors.sort()
    resultText += ` on ${floors.join(', ')} ${pluralize(
      'floor',
      floors.length
    )}`
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'scroll',
          marginBottom: 12,
        }}
      >
        <Text>{resultText}</Text>
        <Table singleLine className="unbordered-table">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Room</Table.HeaderCell>
              <Table.HeaderCell>Reservable</Table.HeaderCell>
              <Table.HeaderCell>Company</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <InteractableList
              items={uniqueSpaces}
              renderItem={renderItem}
              onClick={onClick}
              onMouseOver={data => {
                onMouseOver(data)
              }}
              onMouseOut={onMouseOut}
            />
          </Table.Body>
        </Table>
      </div>
    </>
  )
}
